<template>
  <div class="animated-icon">
    <div class="spinning-outline"></div>
  </div>
</template>

<script setup></script>

<style scoped>
.animated-icon {
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: var(--color-gray-20);
  padding: 0.125rem;
  border-radius: 50%;
}

.spinning-outline {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid transparent;
  border-top-color: var(--border-dark);
  border-radius: 50%;
  animation: spin 4s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
